export const locale = {
  lang: 'fr-CA',
  data: {
    AUTOMATIONS: {
      CREATE_NEW: 'Nouvelle automatisation',
      EDIT_TITLE: 'Modifier l’automatisation',
      FILTER: 'Filtrer…',
      NO_RESULTS: 'Aucune automatisation. Cliquez sur + pour en créer une.',
      NAME: 'Nom',
      WHAT: 'Quoi',
      WHEN: 'Quand',
      PARAM: 'Paramètre',
      ACTION: 'Action',
      ACTIVE: 'Actif',
      LAST_RUN: 'Dernière exécution',
      NEXT_RUN: 'Prochaine',
      NEVER_RUN: 'Jamais exécutée',
      PAUSE_TOOLTIP: 'Mettre en pause (la configuration est conservée)',
      ACTIVATE_TOOLTIP: 'Activer (la prochaine exécution sera recalculée)',
      RUN_NOW: 'Exécuter maintenant',
      RUN_NOW_CONFIRM:
        'Le rapport sera généré et envoyé immédiatement aux destinataires configurés. Continuer?',
      RUN_NOW_SUCCESS: 'Exécution lancée — le courriel partira sous peu.',
      RUN_NOW_CONFIRM_EVENT:
        'Un exemple de paiement fictif, marqué [TEST], sera envoyé immédiatement à la destination configurée. Continuer?',
      RUN_NOW_SUCCESS_EVENT:
        'Exemple envoyé — vérifiez la réception à la destination configurée.',
      TRIGGER: 'Déclencheur',
      TRIGGER_SCHEDULE: 'Planifié',
      TRIGGER_EVENT: 'Sur événement',
      TRIGGER_EVENT_SELECT: 'Événement',
      WHEN_EVENT: 'Sur événement : {{event}}',
      TASK_NOTIFICATION: 'Notification',
      TASK_NOTIFICATION_HINT:
        'À chaque événement, une notification contenant les détails du paiement (facture, client, montant) est livrée à la destination choisie.',
      PARAM_NONE: '—',
      ACTION_WEBHOOK: 'Webhook',
      WEBHOOK_URL: 'URL du webhook (https)',
      WEBHOOK_SECRET: 'Secret (optionnel)',
      WEBHOOK_SECRET_KEPT:
        'Un secret est déjà enregistré. Laissez vide pour le conserver.',
      WEBHOOK_HINT:
        'Un POST JSON est envoyé à cette URL. Avec un secret, l’en-tête « Signature » contient le HMAC-SHA256 du corps JSON.',
      EMAIL_SUBJECT: 'Sujet du courriel (optionnel)',
      EMAIL_SUBJECT_HINT:
        'Variables disponibles : {number} (numéro de facture), {amount} (montant), {client} (nom du client).',
      SUMMARY_EVENT:
        'À chaque « {{event}} », envoyer une notification à {{recipients}} destinataire(s).',
      SUMMARY_EVENT_WEBHOOK:
        'À chaque « {{event}} », envoyer un webhook vers {{host}}.',
      CREATE_SUCCESS: 'Automatisation créée',
      EDIT_SUCCESS: 'Automatisation modifiée',
      TASK_REPORT: 'Rapport',
      TASK_TYPE: 'Type de tâche',
      TASK_PROPOSAL_FOLLOWUP: 'Relance de proposition',
      TASK_PROPOSAL_FOLLOWUP_HINT:
        'Chaque jour à l’heure choisie, les clients dont la proposition est toujours en attente reçoivent un courriel de relance aux étapes configurées (jours après l’envoi de la proposition). La relance s’arrête dès que la proposition est acceptée, refusée ou expirée, ou que l’événement est annulé ou passé.',
      FOLLOWUP_STEP_1: '1re relance (jours)',
      FOLLOWUP_STEP_2: '2e relance (jours)',
      FOLLOWUP_STEP_3: '3e relance (jours)',
      FOLLOWUP_STEPS_INVALID:
        'Les relances doivent être des nombres de jours croissants, entre 1 et 60.',
      FOLLOWUP_STEPS_HINT:
        'Compté depuis l’envoi de la proposition. Au plus une relance par proposition et par jour ; les propositions envoyées bien avant l’activation ne sont pas relancées.',
      FOLLOWUP_TEMPLATE_HINT:
        'Le texte envoyé au client se modifie dans Configuration → Messages de notification → « Relance de proposition ». Il répond directement au vendeur responsable.',
      FOLLOWUP_NOTIFY_INTERNAL:
        'Envoyer un résumé du jour aux destinataires ci-dessous',
      FOLLOWUP_NOTIFY_SELLER:
        'Envoyer à chaque vendeur responsable la liste de ses propositions relancées',
      FOLLOWUP_EMAIL_HINT:
        'Destinataires du résumé interne (plusieurs adresses : séparez-les par une virgule). Les clients ne reçoivent que le courriel de relance.',
      SUMMARY_FOLLOWUP:
        '{{when}}, relancer par courriel les clients dont la proposition est en attente ({{steps}} après l’envoi) et envoyer le résumé à {{recipients}} destinataire(s).',
      RUN_NOW_CONFIRM_FOLLOWUP:
        'Un aperçu marqué [TEST] des relances qui partiraient aujourd’hui vous sera envoyé. Aucun client ne recevra de courriel. Continuer?',
      RUN_NOW_SUCCESS_FOLLOWUP:
        'Aperçu lancé — vérifiez votre boîte de réception.',
      REPORT: 'Rapport',
      PAPER: 'Papier',
      PAPER_LETTER: 'Lettre',
      PAPER_LEGAL: 'Légal',
      ORIENTATION: 'Orientation',
      ORIENTATION_PORTRAIT: 'Portrait',
      ORIENTATION_LANDSCAPE: 'Paysage',
      LANGUAGE: 'Langue',
      FREQ_DAILY: 'Tous les jours',
      FREQ_WEEKLY: 'Chaque semaine',
      FREQ_MONTHLY: 'Chaque mois',
      MONTH_DAY: 'Jour du mois',
      TIME: 'Heure',
      SELECT_AT_LEAST_ONE_DAY: 'Sélectionnez au moins un jour',
      PERIOD: 'Période du rapport',
      PERIOD_HINT:
        '« Demain » est calculé au moment de l’envoi : exécutée le 7 à 19 h, la période sera le 8.',
      DAYS_COUNT: 'Nombre de jours',
      PRESET_TODAY: 'Aujourd’hui',
      PRESET_TOMORROW: 'Demain',
      PRESET_NEXT_N_DAYS: 'Les {{n}} prochains jours',
      PRESET_NEXT_N_DAYS_OPTION: 'Les N prochains jours',
      PRESET_CURRENT_WEEK_PLUS_2:
        'Semaine en cours + 2 semaines (lundi au dimanche)',
      ACTION_TYPE: 'Destination',
      ACTION_EMAIL: 'Courriel',
      ACTION_GOOGLE_DRIVE: 'Google Drive',
      ACTION_ONEDRIVE: 'OneDrive',
      ONEDRIVE_HINT:
        'Le rapport est déposé dans le dossier d’application OneDrive relié à l’organisation (Configuration → Intégrations → OneDrive) : PDF et Excel tels quels.',
      DRIVE_HINT:
        'Le rapport est déposé dans le Google Drive relié à l’organisation (Configuration → Intégrations → Google Drive) : PDF tel quel, Excel converti en Google Sheet.',
      DRIVE_OVERWRITE: 'Remplacer le même fichier à chaque exécution',
      DRIVE_OVERWRITE_SHORT: 'fichier unique',
      DRIVE_OVERWRITE_HINT:
        'Coché : un seul fichier nommé comme le rapport, mis à jour à chaque exécution (lien stable). Décoché : une nouvelle copie datée à chaque exécution.',
      EMAIL_TO: 'À',
      EMAIL_CC: 'Cc',
      EMAIL_BCC: 'Cci',
      EMAIL_HINT: 'Plusieurs adresses : séparez-les par une virgule.',
      WHEN_DAILY: 'Tous les jours à {{time}}',
      WHEN_WEEKLY: 'Chaque {{days}} à {{time}}',
      WHEN_MONTHLY: 'Le {{day}} du mois à {{time}}',
      DAY_MO: 'lun.',
      DAY_TU: 'mar.',
      DAY_WE: 'mer.',
      DAY_TH: 'jeu.',
      DAY_FR: 'ven.',
      DAY_SA: 'sam.',
      DAY_SU: 'dim.',
      DAY_SHORT_MO: 'L',
      DAY_SHORT_TU: 'M',
      DAY_SHORT_WE: 'M',
      DAY_SHORT_TH: 'J',
      DAY_SHORT_FR: 'V',
      DAY_SHORT_SA: 'S',
      DAY_SHORT_SU: 'D',
      SUMMARY:
        '{{when}}, envoyer le rapport « {{report}} » couvrant {{param}}, à {{recipients}} destinataire(s).',
      SUMMARY_DRIVE:
        '{{when}}, déposer le rapport « {{report}} » couvrant {{param}} dans Google Drive.',
      SUMMARY_ONEDRIVE:
        '{{when}}, déposer le rapport « {{report}} » couvrant {{param}} dans OneDrive.',
    },
  },
};
